import { render, staticRenderFns } from "./TahunAjaranForm.vue?vue&type=template&id=5b8875a0"
import script from "./TahunAjaranForm.vue?vue&type=script&lang=js"
export * from "./TahunAjaranForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports